let linkPatterns = [
    // submitPattern 含class
    [
        /\[link\s+submit=['"]+([^[\]'"]+)['"]+\s+class=['"]+([^[\]'"]+)['"]+\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi,
        '<a id="submitLink" href="javascript:void(0);" class="$2 a-link">$3</a><span style="display:none;">$1</span>'],
    // submitPattern
    [
        /\[link\s+submit=['"]+([^[\]'"]+)['"]+\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi,
        '<a id="submitLink" href="javascript:void(0);" class="a-link">$2</a><span style="display:none;">$1</span>'],
    [
        /\[link\s+submit=([^\s[\]'"]+)\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi,
        '<a id="submitLink" href="javascript:void(0);" class="a-link">$2</a><span style="display:none;">$1</span>'],
    // defalutPattern
    [
        /\[link\](.*?)\[\/link\]/gi,
        '<a id="submitLink" href="javascript:void(0);" class="a-link">$1</a>'],
    [
        /<a id="submitLink".*?>.*?<\/a>/gi,
        function (p) {
            return p.replace(/(http|ftp|https)/gi, '$1_');
        }],
    // urlPattern
    [
        /\[link\s+url=['"]+([^[\]'"]+)['"]+\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi,
        '<a href="$1" target="_blank">$2</a>'],
    [
        /\[link\s+url=([^\s[\]'"]+)\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi,
        '<a href="$1" target="_blank">$2</a>'],
    // p4Pattern1
    [
        /\[link\s+p4=['"]+([^[\]'"]+)['"]+\s+title=['"]+([^[\]'"]+)['"]+\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi,
        '<a href="javascript:void(0);" onclick="robot.customService(\'$1\',\'$2\',this);return false;" >$3</a>'],
    [
        /\[link\s+p4=([^\s[\]'"]+)\s+title=([^\s[\]'"]+)\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi,
        '<a href="javascript:void(0);" onclick="robot.customService(\'$1\',\'$2\',this);return false;" >$3</a>'],
    // p4Pattern2
    [
        /\[link\s+p4=['"]+([^[\]'"]+)['"]+\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi,
        '<a href="javascript:void(0);" onclick="robot.customService(\'$1\',\'$2\',this);return false;" >$2</a>'],
    [
        /\[link\s+p4=([^\s[\]'"]+)\s*[^[\]]*\]([^[\]]+)\[\/link\]/gi,
        '<a href="javascript:void(0);" onclick="robot.customService(\'$1\',\'$2\',this);return false;" >$2</a>']
];
const emoBoxlist = ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '可爱', '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手', '激动', '街舞', '献吻', '左太极', '右太极'];

let formatMsg = function (content) {
    return content.replace(/\[[\u4E00-\u9FA5]{1,3}\]/gi, function (word) {
        let newWord = word.replace(/\[|\]/gi, '');
        let index = emoBoxlist.indexOf(newWord);
        return `<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif" align="top">`;
    });
};

export default {
    // 表情列表
    emoBoxlist,
    // 判断是否为空
    isEmpty(value) {
        let flag = false;
        if (value === null || value === 'null' || value === '' || value === undefined) {
            flag = true;
        }
        return flag;
    },
    formatMsg,
    // 格式化文本内容
    convertMsg(body) {
        let htmlContent = body;
        let title = '';
        htmlContent = htmlContent.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
        htmlContent = htmlContent.replace(/\[href=.[^[\]]*\]/g, function (Regstr, $1, $2, $3, newstrObj) {
            const name = Regstr.match(/\[href=(.*?)\]/)[1];
            return '<a href="' + window.location.href + '" ' + '>' + name + '</a>';
        }).replace(/\[content=.[^[\]]*\]/g, function (Regstr, $1, $2, $3, newstrObj) {
            const name = Regstr.match(/\[content=(.*?)\]/)[1];
            return name;
        }).replace(/\[name=.[^[\]]*\]/g, function (Regstr, $1, $2, $3, newstrObj) {
            const name = Regstr.match(/\[name=(.*?)\]/)[1];
            title = name;
            return '';
        }).replace(/\[url=.[^[\]]*\]/g, function (Regstr, $1, $2, $3, newstrObj) {
            const name = Regstr.match(/\[url=(.*?)\]/)[1];
            return '<a href="' + name + '" target="_blank">' + title + '</a>';
        });
        for (var i = 0; i < linkPatterns.length; i++) {
            htmlContent = htmlContent.replace(linkPatterns[i][0], linkPatterns[i][1]);
        }
        htmlContent = formatMsg(htmlContent);
        return htmlContent;
    },
    getOpenId() {
        var s = [];
        var hexDigits = '0123456789abcdef';
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = '4';
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
        s[8] = s[13] = s[18] = s[23] = '-';

        var uuid = s.join('');
        return uuid;
    },
    getRandomAlphaNum(len) {
        var rdmString = '';
        for (; rdmString.length < len; rdmString += Math.random().toString(36).substr(2));
        return rdmString.substr(0, len);
    },
    getUrlParams(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        let url = location.search; // 获取url中"?"符后的字串
        let str = url.substr(1).match(reg);
        if (str != null) {
            return unescape(str[2]);
        }
        return null;
    },
    formatTime(fmt, date) {
        let ret;
        const opt = {
            'Y+': date.getFullYear().toString(),        // 年
            'm+': (date.getMonth() + 1).toString(),     // 月
            'd+': date.getDate().toString(),            // 日
            'H+': date.getHours().toString(),           // 时
            'M+': date.getMinutes().toString(),         // 分
            'S+': date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp('(' + k + ')').exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')));
            };
        };
        return fmt;
    }
};



// WEBPACK FOOTER //
// ./src/common/common.js